var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("page", [
    _c("div", { staticClass: "page-title" }, [_vm._v("存款管理")]),
    _c(
      "div",
      { staticClass: "page-content", staticStyle: { padding: "0" } },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "存款中", name: "pending" } },
              [_c("DepositPendingTab", { on: { update: _vm.handleUpdate } })],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "历史记录", name: "history" } },
              [_c("DepositHistoryTab", { on: { update: _vm.handleUpdate } })],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "存款档位设置", name: "tier" } },
              [
                _c("ManageDepositTierTab", {
                  on: { update: _vm.handleUpdate },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }